import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { PiPaperPlaneTilt } from 'react-icons/pi';
import { LiaExchangeAltSolid } from 'react-icons/lia';
import { ChainId } from '@shared/utils/config/networks';
import { getUrls } from '@shared/utils/config/environment';
import { TPnLData } from '@shared/types/frontend/assetPage';
interface DTPortfolioAssetsRowProps {
  props: any;
  PKP: any;
  handleClick: (row: any) => void;
  setSendModalData: (data: {
    address: string;
    network: number;
  }) => void;
}
const DTPortfolioAssetsRow = ({
  props,
  PKP,
  handleClick,
  setSendModalData
}: DTPortfolioAssetsRowProps) => {
  const router = useRouter();
  const [showTooltip, setShowTooltip] = useState(false);
  const [showBuyTooltip, setShowBuyTooltip] = useState(false);
  const [showSellTooltip, setShowSellTooltip] = useState(false);
  const [showSwapTooltip, setShowSwapTooltip] = useState(false);
  const [showSendTooltip, setShowSendTooltip] = useState(false);
  const {
    data: tokenPnLData,
    isLoading
  } = useQuery({
    queryKey: ['pnlData', props.row?.contract_address, props.row?.network],
    queryFn: async (): Promise<TPnLData | undefined> => {
      const data = await fetch(`${getUrls().INDEXER_URL}/portfolio/holdings?address=${props.row?.network == ChainId.SOLANA ? PKP?.solanaAddress : PKP?.additionalEthAddress}&token=${props.row?.contract_address}&chains=${props.row?.network}`).then(res => res.json());
      const pnls = data?.pnls?.[0] ?? null;
      return pnls;
    },
    refetchInterval: 10000
  });
  function toggleSendModal(e) {
    e.stopPropagation();
    setSendModalData({
      address: props.row.contract_address,
      network: props.row.network
    });
    setShowTooltip(false);
    setShowSendTooltip(false);
  }
  props.row.tokenPnLData = tokenPnLData;
  props.row.isLoading = isLoading;
  return <>
      <tr {...props} className='hover:bg-genius-blue transition-colors cursor-pointer relative' onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} onClick={(e: any) => {
      const isFlexButton = e.target.classList.contains('flexButton');
      const clickOffDialog = e.target.classList.contains('dialog-layout');
      if (isFlexButton || clickOffDialog) {
        return;
      } else {
        handleClick(props.row);
        router.push(`/asset?address=${props.row.contract_address}&networkId=${props.row.network}`);
      }
    }}>
        {props.children}
        {showTooltip && <div className='absolute bottom-[1px] left-[95px] flex items-center justify-center bg-black rounded-full border-genius-blue border-[1px] p-1 gap-[1.5px]'>
            <Link href={`/asset?address=${props.row.contract_address}&networkId=${props.row.network}&tradeSide=buy`} onClick={e => e.stopPropagation()}>
              <div onMouseEnter={() => setShowBuyTooltip(true)} onMouseLeave={() => setShowBuyTooltip(false)} className='w-[20px] h-[20px] relative bg-genius-blue hover:bg-[#34D399] hover:text-genius-blue rounded-full flex justify-center items-center'>
                <div className={`${showBuyTooltip ? 'visible' : 'hidden'} absolute top-[-25px] text-[12px] h-[21px] bg-[#34D399] text-genius-blue flex items-center px-2 rounded-md left-[-7px]`}>
                  Buy
                </div>
                <div className='cursor-pointer h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center'>
                  +
                </div>
              </div>
            </Link>
            <Link href={`/asset?address=${props.row.contract_address}&networkId=${props.row.network}&tradeSide=sell`} onClick={e => e.stopPropagation()}>
              <div onMouseEnter={() => setShowSellTooltip(true)} onMouseLeave={() => setShowSellTooltip(false)} className='cursor-pointer w-[20px] h-[20px] relative bg-genius-blue hover:bg-[#F87171] hover:text-genius-blue rounded-full flex justify-center items-center'>
                <div className={`${showSellTooltip ? 'visible' : 'hidden'} absolute top-[-25px] text-[12px] h-[21px] bg-[#F87171] text-genius-blue flex items-center px-2 rounded-md left-[-7px]`}>
                  Sell
                </div>
                <div className='h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center'>
                  -
                </div>
              </div>
            </Link>
            <Link href={`/trade?address=${props.row.contract_address}&networkId=${props.row.network}&side=from`} onClick={e => e.stopPropagation()}>
              <div onMouseEnter={() => setShowSwapTooltip(true)} onMouseLeave={() => setShowSwapTooltip(false)} className='cursor-pointer w-[20px] h-[20px] relative bg-genius-blue hover:bg-genius-pink hover:text-genius-blue rounded-full flex justify-center items-center'>
                <div className={`${showSwapTooltip ? 'visible' : 'hidden'} absolute top-[-25px] text-[12px] h-[21px] bg-genius-pink text-genius-blue flex items-center px-2 rounded-md left-[-7px]`}>
                  Swap
                </div>
                <div className='h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center'>
                  <LiaExchangeAltSolid />
                </div>
              </div>
            </Link>
            <div onClick={toggleSendModal} onMouseEnter={() => setShowSendTooltip(true)} onMouseLeave={() => setShowSendTooltip(false)} className='cursor-pointer w-[20px] h-[20px] relative bg-genius-blue hover:bg-genius-pink hover:text-genius-blue rounded-full flex justify-center items-center'>
              <div className={`${showSendTooltip ? 'visible' : 'hidden'} absolute top-[-25px] text-[12px] h-[21px] bg-genius-pink text-genius-blue flex items-center px-2 rounded-md left-[-7px]`}>
                Send
              </div>
              <div className='h-[14px] w-[14px] p-[1px] rounded-full items-center flex justify-center m-auto'>
                <PiPaperPlaneTilt />
              </div>
            </div>
          </div>}
      </tr>
    </>;
};
export default DTPortfolioAssetsRow;